import { enqueueSnackbar } from 'notistack';
import { ERROR } from './constant';

export const handleFetchDetailError = (error: any, setError: any, fieldError: string) => {
  error?.details.forEach((detail: any) => {
    switch (detail.code) {
      case ERROR.RESOURCE_NOT_FOUND:
        enqueueSnackbar(detail.message, { variant: 'error' });
        setError(fieldError, { type: 'custom', message: detail.message });
        break;

      default:
        enqueueSnackbar('Đã có lỗi xảy ra ! Vui lòng thử lại !', { variant: 'error' });
        break;
    }
  });
};

export function handleGeneralError(field: any, alias: any, error: any, setError: any) {
  console.log(error);
  if (!error) {
    enqueueSnackbar('Đã có lỗi xảy ra ! Vui lòng thử lại !', { variant: 'error' });
    return;
  }
  switch (error.code) {
    case ERROR.DATA_ALREADY_EXISTS:
      enqueueSnackbar(`${field} đã tồn tại`, { variant: 'error' });
      setError(alias, { type: 'custom', message: `${field} đã tồn tại` });
      break;
    case ERROR.DATA_INCORRECT_FORMAT:
      if (field) {
        enqueueSnackbar(`${field} không hợp lệ`, { variant: 'error' });
        setError(alias, { type: 'custom', message: `${field} không hợp lệ` });
      } else {
        enqueueSnackbar(error.message, { variant: 'error' });
      }
      break;
    case ERROR.MISSING_DATA:
      enqueueSnackbar(`${field} bị bỏ trống !`, { variant: 'error' });
      setError(alias, { type: 'custom', message: `Bạn chưa nhập ${field}` });
      break;
    case ERROR.RESOURCE_NOT_FOUND:
      enqueueSnackbar(error.message, { variant: 'error' });
      setError(alias, { type: 'custom', message: error.message });
      break;
    case ERROR.INVALID_DATA:
      enqueueSnackbar(error.message, { variant: 'error' });
      setError(alias, { type: 'custom', message: error.message });
      break;
    case ERROR.LIST_IS_DUPLICATED:
      enqueueSnackbar(error.message, { variant: 'error' });
      setError(alias, { type: 'custom', message: error.message });
      break;
    default:
      enqueueSnackbar('Đã có lỗi xảy ra ! Vui lòng thử lại !', { variant: 'error' });
      break;
  }
}
export function handleGeneralErrors(fields: any, fieldAlias: any, errors: any, setError: any) {
  console.log(errors);
  if (!errors?.details) {
    enqueueSnackbar('Đã có lỗi xảy ra ! Vui lòng thử lại !', { variant: 'error' });
    return;
  }
  errors.details?.forEach((detail: any) => {
    const field = fields[detail.field];
    const alias = detail.field in fieldAlias ? fieldAlias[detail.field] : detail.field;
    handleGeneralError(field, alias, detail, setError);
  });
}
